import React from "react";

const CustomTextarea = ({
    label,
    name,
    value,
    onChange,
    placeholder,
    rows = 4,
    maxLength,
    error,
    className,
    inputStyle,
    labelStyle,
    disabled = false
}) => {
    return (
        <div className={`relative ${className}`}>
            <div className="relative flex flex-col gap-0.5">
                {label && (
                    <label
                        htmlFor={name}
                        className={`block text-sm ${labelStyle}`}
                    >
                        {label}
                    </label>
                )}
                <textarea
                    id={name}
                    name={name}
                    value={value}
                    onChange={onChange}
                    rows={rows}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    disabled={disabled}
                    className={`
                        w-full px-4 py-2  text-sm border-2 border-gray-200 rounded-xl
                        resize-none focus:outline-none
                        ${error ? "border-red-500" : ""}
                        ${disabled ? "bg-gray-100 text-gray-500 cursor-not-allowed" : "bg-input-bg"}
                        ${inputStyle}
                    `}
                />
            </div>

            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </div>
    );
};

export default CustomTextarea;
